import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import TranslateIcon from '@mui/icons-material/Translate';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ElectricBoltIcon from '@mui/icons-material/ElectricBolt';
import MapIcon from '@mui/icons-material/Map';
import HomeIcon from '@mui/icons-material/Home';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import HvacIcon from '@mui/icons-material/Hvac';
import { Summarize } from '@mui/icons-material';
import MenuIcon from '@mui/icons-material/Menu';
import TimelineIcon from '@mui/icons-material/Timeline';
import ReportIcon from '@mui/icons-material/Report';
import LogoutIcon from '@mui/icons-material/Logout';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Select from '@mui/material/Select';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import logo from '../logo.png';
import TaskIcon from '@mui/icons-material/Task';
import { useTranslation } from "react-i18next";

const drawerWidth = 240;

function ResponsiveDrawer(props) {

  const { window, element, title, onLogout, language, 
    onLanguageChange, hiddenPages, facilities, selectedFacility, onFacilityChange } = props;

  const { t } = useTranslation();

  const languages = ["en", "tr"]

  const [mobileOpen, setMobileOpen] = React.useState(false);  

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClickFacilityMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseFacilityMenu = () => {
    setAnchorEl(null);
  };
  const handleSelectFacility = (val) => {
    onFacilityChange(val);
    setAnchorEl(null);
  };


  React.useEffect(() => 
    {
        setMobileOpen(false);
     }, 
    [element]
  );

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawer = (
    <React.Fragment>
      <Toolbar>
        <Box sx={{width:"100%"}}>
        <img src={logo} width="100%" alt="XWatts"/>
        </Box>
      </Toolbar>
      <Divider />
      <List>
        <ListItem disablePadding>
          <ListItemButton component={Link} to="/">
            <ListItemIcon>
              <HomeIcon />
            </ListItemIcon>
            <ListItemText primary={t("Home")} />
          </ListItemButton>
        </ListItem>
        { !hiddenPages.includes("automation") &&
        <ListItem disablePadding>
          <ListItemButton component={Link} to="/automation">
            <ListItemIcon>
              <CalendarMonthIcon />
            </ListItemIcon>
            <ListItemText primary={t("Automation")} />
          </ListItemButton>
        </ListItem>
        }
        { !hiddenPages.includes("monitoring") &&
        <ListItem disablePadding>
          <ListItemButton component={Link} to="/monitoring">
            <ListItemIcon>
              <MapIcon />
            </ListItemIcon>
            <ListItemText primary={t("Monitoring")} />
          </ListItemButton>
        </ListItem>
        }
        { !hiddenPages.includes("cogeneration") &&
        <ListItem disablePadding>
          <ListItemButton component={Link} to="/cogeneration">
            <ListItemIcon>
              <ElectricBoltIcon />
            </ListItemIcon>
            <ListItemText primary={t("Generation")} />
          </ListItemButton>
        </ListItem>
        }
        { !hiddenPages.includes("alerts") &&
        <ListItem disablePadding>
          <ListItemButton component={Link} to="/alerts">
            <ListItemIcon>
              <ReportIcon />
            </ListItemIcon>
            <ListItemText primary={t("Alerts")} />
          </ListItemButton>
        </ListItem>
        }
        { !hiddenPages.includes("tasks") &&
        <ListItem disablePadding>
          <ListItemButton component={Link} to="/tasks">
            <ListItemIcon>
              <TaskIcon/>
            </ListItemIcon>
            <ListItemText primary={t("Tasks")} />
          </ListItemButton>
        </ListItem>
        }
        { !hiddenPages.includes("trends") &&
        <ListItem disablePadding>
          <ListItemButton component={Link} to="/trends">
            <ListItemIcon>
              <TimelineIcon />
            </ListItemIcon>
            <ListItemText primary={t("Trends")} />
          </ListItemButton>
        </ListItem>
        }
        {!hiddenPages.includes("reports") &&
        <ListItem disablePadding>
          <ListItemButton component={Link} to="/reports">
            <ListItemIcon>
              <Summarize />
            </ListItemIcon>
            <ListItemText primary={t("Reports")} />
          </ListItemButton>
        </ListItem>
        }
        { !hiddenPages.includes("settings") &&
        <ListItem disablePadding>
          <ListItemButton component={Link} to="/settings">
            <ListItemIcon>
              <HvacIcon />
            </ListItemIcon>
            <ListItemText primary={t("Settings")} />
          </ListItemButton>
        </ListItem>
        }
      </List>
      <Divider />
      <List>
        <ListItem >
            <ListItemIcon>
              <TranslateIcon />
            </ListItemIcon>
            <FormControl size="small" variant="standard">
              <Select value={language} onChange={(event)=>onLanguageChange(event.target.value)}>
                {
                  languages.map((item)=>(
                      <MenuItem key={item} value={item}>
                        {t(item)}
                      </MenuItem>
                  ))
                }
              </Select>
            </FormControl>

        </ListItem>
        <ListItem disablePadding>
          <ListItemButton onClick={()=>onLogout()}>
            <ListItemIcon>
              <LogoutIcon />
            </ListItemIcon>
            <ListItemText primary={t("Log out")} />
          </ListItemButton>
        </ListItem>
      </List>
    </React.Fragment>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <React.Fragment >
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
        }}
      >
        <Toolbar style={{backgroundColor: "#1976d2", color: 'white'}}>
        <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: 'none' } }}
          >
            <MenuIcon />
         </IconButton>
          <Button
            onClick={handleClickFacilityMenu}
            sx={{textTransform: 'none'}}
            variant="contained"
            disableElevation
            endIcon={<ArrowDropDownIcon />}
          >
            <Typography variant="h6" color="white" >
              {facilities.filter((f)=>f.url === selectedFacility)[0]?.name}
            </Typography>
          </Button>
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleCloseFacilityMenu}
          >
            {
              facilities.map((f) => <MenuItem key={f.url} onClick={()=>handleSelectFacility(f.url)}>{f.name}</MenuItem>)
            }
          </Menu>
          <Typography variant="h6" noWrap component="div" marginLeft={1} marginRight={2}>
            {"/"}
          </Typography>
          <Typography variant="h6" noWrap component="div">
            {title}
          </Typography>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="navigation menu"
      >
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: {xs: 'none', sm: 'block'},
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
      <Box
        component="main"
        sx={{ width: { sm: `calc(100% - ${drawerWidth}px)` }, marginLeft: {sm: drawerWidth+"px"} }}
      >
        <Toolbar />
        {element}
      </Box>
    </React.Fragment>
  );
}

export default ResponsiveDrawer;
